import React from 'react'
import './Goals.css';

function Goals() {
  return (
    <>
    <div className='goals'>
        <div className='goals_title'>
        <br></br>
            <h1> نبذة عن المشروع </h1>
            
            <br/><br/>

                <div className='video_container'>
                    <h6>يدخل هذا المشروع ضمن المشاريع الاجتماعية والخيرية المزمع إنجازها في إطار برامج استراتيجية النهوض بالوقف رؤية 2032 والتي من بينها برنامج تأهيل وبناء مؤسسات اجتماعية وخيرية وقفية، حيث أن هذا المشروع يهدف إلى بناء الدار الكبيرة لكفالة اليتيم، مما سيعطي دفعة اجتماعية مهمة لهذه المنطقة.</h6>
                    <video poster="poster_video.png" src='https://www.elysium.ma/assets_elysium/vd1.mp4' controls></video>
                </div>

            <br/><br/>

            <h2 align="center" > : أهدافنا</h2>

        </div>
        
        <div className='goals-cards'>

            <div className='goal-card'>
                <div className='image'>
                    <img src='ICONE 4.png' alt='dar lkbira'/>
                </div>
                <h2>بناء مستقبل</h2>
                <p>نعدّهم ليكونوا أفرادًا فاعلين في المجتمع، قادرين على تحقيق أحلامهم والمساهمة في تنميته</p>
            </div>

            <div className='goal-card'>
                <div className='image'>
                    <img src='ICONE 3.png' alt='dar lkbira'/>
                </div>
                <h2>تمكين</h2>
                <p>نحرص على تزويدهم بالمهارات والمعرفة التي تعزز استقلاليتهم وقدرتهم على النجاح</p>
            </div>

            <div className='goal-card'>
                <div className='image'>
                    <img src='ICONE 2.png' alt='dar lkbira'/>
                </div>
                <h2>رعاية</h2>
                <p>نهتم بصحتهم، وتعليمهم، وتوفير بيئة آمنة تضمن نموهم السليم</p>
            </div>

            <div className='goal-card'>
                <div className='image'>
                    <img src='ICONE 1.png' alt='dar lkbira'/>
                </div>
                <h2>كفالة</h2>
                <p>نوفر الدعم  لضمان حياة مستقرة وكريمة لكل يتيم</p>
            </div>
            
        </div>
        <br></br>
    </div>

    </>
  )
}

export default Goals